import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {AnalyticsHomeRouteComponent} from "./-homeRouteComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/analytics")({
    loader: ({context}) => ({accessToken: context.authenticationStatus.accessToken, intellsysBaseUrl: context.intellsysBaseUrl}),
    component: AnalyticsHomeRouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
